/* eslint-disable jsx-a11y/alt-text */
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer'

import { getPdfBadgeColors } from '@/components/organisms/Viewer/pdfTheme'
import { picturesFormater } from '@/services/adapters'

export const PortraitDefault = ({ category, item, settings }) => {
  const { name, pictures, productItems } = item
  const picturesURLs = picturesFormater(pictures, 'original')
  return (
    <>
      <View style={{ display: 'flex', flexDirection: 'row' }}>
        {picturesURLs?.slice(0, 3).map((url) => (
          <View style={styles.imageContainer} key={`picture-${url}`}>
            <Image src={url} style={styles.image} />
          </View>
        ))}
      </View>

      <View style={[styles.section, { marginTop: '0.5cm' }]}>
        <Text style={[styles.chip, getPdfBadgeColors(settings?.color)]}>
          {category || 'Fiche produit'}
        </Text>
        <Text style={styles.title}>{name}</Text>
        <View style={styles.table}>
          {productItems.map((item) => (
            <View
              style={[styles.tableRow, item.space && styles.spacedRow]}
              key={item.name}
            >
              <View
                style={[
                  styles.tableCol,
                  styles.colLabel,
                  item.merge && styles.mergedCell,
                ]}
              >
                <Text
                  style={[
                    styles.tableCell,
                    settings?.color
                      ? { color: settings.color }
                      : { color: '#5c5a5a' },
                  ]}
                >
                  {item.name}
                </Text>
              </View>
              <View style={[styles.tableCol, item.merge && styles.mergedCell]}>
                {item.value ? (
                  <View style={[styles.tableCell, styles.indicator]}>
                    {[1, 2, 3, 4].map((i) => {
                      return (
                        <View key={i}>
                          {i - 1 < item.value ? (
                            <Image
                              src="/icon/square-solid.svg"
                              style={{
                                width: 8,
                                height: 8,
                                marginRight: 2,
                                backgroundColor: 'black',
                              }}
                            />
                          ) : (
                            <Image
                              src="/icon/square-outline.svg"
                              style={{
                                width: 8,
                                height: 8,
                                marginRight: 2,
                                backgroundColor: '#CCC',
                              }}
                            />
                          )}
                        </View>
                      )
                    })}
                    <Text
                      style={{ fontSize: 9, color: 'black', marginLeft: 8 }}
                    >
                      {item.title}
                    </Text>
                  </View>
                ) : (
                  <Text style={styles.tableCell}>{item.title}</Text>
                )}
                {item.subTitle && (
                  <Text style={[styles.tableCell, { color: '#5c5a5a' }]}>
                    {item.subTitle}
                  </Text>
                )}
                {item.description && (
                  <Text style={styles.tableCell}>{item.description}</Text>
                )}
              </View>
            </View>
          ))}
        </View>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  header: {
    marginTop: '-0.5cm',
    height: '2cm',
    display: 'flex',
    flexDirection: 'row',
    marginRight: '1cm',
    marginBottom: '0.5cm',
  },
  logo: {
    width: '3cm',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  logoImage: {
    maxWidth: '3cm',
  },
  headerTitle: {
    marginLeft: '0.5cm',
    justifyContent: 'center',
  },
  titleText: {
    fontSize: 9,
    fontWeight: 'thin',
    color: '#858484',
  },
  chip: {
    fontSize: 12,
    paddingVertical: 2,
    paddingHorizontal: 6,
    marginBottom: 8,
    borderRadius: 2,
    backgroundColor: '#858484',
    color: '#fff',
    alignSelf: 'flex-start',
  },
  table: {
    display: 'flex',
    width: 'auto',
    borderStyle: 'solid',
  },
  tableRow: {
    flexDirection: 'row',
  },
  colLabel: {
    width: '6cm',
  },
  tableCol: {
    width: '70%',
    borderStyle: 'solid',
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    paddingBottom: 6,
  },
  tableCell: {
    marginTop: 6,
    fontSize: 10,
  },
  mergedCell: {
    borderBottom: 0,
    paddingBottom: 0,
  },
  spacedRow: {
    marginTop: 16,
  },
  page: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1.5cm',
    marginTop: '1.5cm',
  },
  section: {
    width: '18cm',
  },
  title: {
    fontWeight: 'bold',
    paddingBottom: 12,
  },
  subTitle: {
    color: '#343232',
    paddingBottom: '1cm',
    fontSize: 14,
  },
  imageContainer: {
    width: '5.7cm',
    maxHeight: '8.5cm',
    marginRight: '0.45cm',
    borderRadius: 2,
    overflow: 'hidden',
    backgroundColor: '#F5F5F5',
  },
  image: {
    width: '5.7cm',
    height: '8.5cm',
    objectFit: 'cover',
  },
  indicator: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: 3,
  },
})
